export default __webpack_public_path__ + "static/media/right-example.431efae7.png";